import styled from '@emotion/styled'
import React, { ReactNode, forwardRef } from 'react'

import { BoxProps, box } from './Box'

type ClickableElementProps = {
  cursor?: string
  accessKey?: string
  hoverColor?: string
  hoverBackgroundColor?: string
  darkenOnHover?: boolean
}

const ClickableElement = styled.button<ClickableElementProps>((props) => ({
  padding: 0,
  background: 'none',
  border: 'none',
  ...box(props),
  cursor: props.cursor ?? 'pointer',
  ':hover': {
    color: props.hoverColor,
    backgroundColor: props.hoverBackgroundColor,
    ...(props.darkenOnHover && {
      filter: 'brightness(0.95)',
    }),
  },
}))

export type ClickableDeprecatedProps = ClickableElementProps &
  BoxProps & {
    children?: ReactNode
    onClick?: (e: React.MouseEvent<Element>) => void
    title?: string
  }

/**
 * @deprecated
 */
export const ClickableDeprecated = forwardRef<
  HTMLButtonElement,
  ClickableDeprecatedProps
>((props, ref) => {
  const { children, accessKey, ...elementProps } = props

  return (
    <ClickableElement {...elementProps} accessKey={accessKey} ref={ref}>
      {children}
    </ClickableElement>
  )
})

ClickableDeprecated.displayName = 'ClickableDeprecated'
